import React from 'react'

import { cn } from '@/helpers/cn'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'text'
  size?: 'sm' | 'md'
  loading?: boolean
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', size = 'md', loading = false, disabled, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        disabled={disabled || loading}
        className={cn(
          'inline-flex items-center justify-center whitespace-normal rounded-xs p-2.5 font-bold font-sans text-base transition-colors duration-200',
          'cursor-pointer disabled:cursor-not-allowed',

          variant === 'primary' &&
            `border-2 border-button-primary bg-button-primary text-body-text-light hover:border-button-hover hover:bg-button-hover disabled:border-button-disabled disabled:bg-button-disabled disabled:text-button-text-disabled`,
          variant === 'text' &&
            `border-0 bg-transparent text-link-default hover:border-0 hover:bg-transparent hover:text-link-hover disabled:border-button-disabled disabled:bg-button-disabled disabled:text-button-text-disabled`,
          variant === 'outline' &&
            `border-2 border-button-hover bg-transparent text-link-default hover:border-button-hover hover:bg-button-hover hover:text-body-text-light disabled:border-button-disabled disabled:bg-button-disabled disabled:text-button-text-disabled`,
          className
        )}
        {...props}
      >
        {loading ? (
          <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
        ) : (
          children
        )}
      </button>
    )
  }
)

Button.displayName = 'Button'
